<template>
<div class="custom-input">
	<i :class="'input-' + inputStyle + ' ' + iconClass" v-if="iconClass"></i>
	<input
		v-bind="$attrs"
		:class="inputStyle + ' ' + (iconClass ? 'input-icon' : '')"
		:value="value"
		v-on="listeners"
	/>
</div>
</template>

<script>
export default {
	props: [
		'iconClass',
		'inputStyle',
		'value'
	],
	computed: {
		listeners() {
			var vm = this
			return Object.assign(
				{},
				this.$listeners,
				{
					input: function(event) {
						vm.$emit('input', event.target.value)
					}
				}
			)
		}
	}
}
</script>

<style lang="scss">
.custom-input {
	position: relative;

	input {
		border: none;
		font-size: 13px;
		display: block;
		font-weight: 700;
		padding: 16px 16px 16px 21px;
		border-radius: 0;
		width: fill-available;
		margin-bottom: 7px;
		outline: none;

		&::placeholder {
			font-weight: 500;
			opacity: 1;
		}
	}
	input.input-icon {
		padding-left: 40px;
	}
	input.dark {
		background-color: rgba(20, 26, 33, 0.8);
		color: #fff;

		&::placeholder {
			color: #fff;
		}
	}

	input.light {
		background-color: #fdfcfb;
		color: #252525;
		border: 1px solid #fff;

		&::placeholder {
			color: #6b6b6b;
		}
	}

	i {
		position: absolute;
		left: 3px;
		top: 8px;
		font-size: 22px;
	}

	i.input-dark {
		color: #fff;
	}

	i.input-dark {
		color: #252525;
	}
}

</style>
